// extracted by mini-css-extract-plugin
module.exports = {"buyComponent":"Buy_buyComponent__1uWiV"};